"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistryAccessErrors__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [],
  name: "InvalidAdminAddress",
  type: "error"
}];

class RegistryAccessErrors__factory {
  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.RegistryAccessErrors__factory = RegistryAccessErrors__factory;

_defineProperty(RegistryAccessErrors__factory, "abi", _abi);